import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {Container} from "@pg-design/grid-module";
import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../../app/rp_reducer";
import {SchemaArticleAuthorDetail} from "../../schemas/SchemaArticleAuthorDetail";
import {AuthorArticlesListing} from "./AuthorArticlesListing";
import {AuthorDescription} from "./AuthorDescription";

export const ArticleAuthorsDetailView = () => {
    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author.name);
    const description = useSelector((state: IRPStore) => state.article.authorDetail.author.description);
    const locationPathname = useLocation().pathname;
    const authorImageUrl = useSelector((state: IRPStore) => state.article.authorDetail.author.image?.a_img_360x360);

    return (
        <Container>
            <SchemaArticleAuthorDetail name={authorName} description={description} pathname={locationPathname} authorImageUrl={authorImageUrl} />
            <Breadcrumbs css={mb(8)} homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Wiadomości" position="2" url={rpAppLink.article.list()} />
                <BreadcrumbsItem name="Autorzy" position="3" url={rpAppLink.article.author.list()} />
                <BreadcrumbsItem name={authorName} position="4" isLinkingToCurrentLocation />
            </Breadcrumbs>

            <AuthorDescription css={[mb(3), onDesktop(mb(8))]} />
            <AuthorArticlesListing />
        </Container>
    );
};
import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {Container} from "@pg-design/grid-module";
import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../../app/rp_reducer";
import {SchemaArticleAuthorDetail} from "../../schemas/SchemaArticleAuthorDetail";
import {AuthorArticlesListing} from "./AuthorArticlesListing";
import {AuthorDescription} from "./AuthorDescription";

export const ArticleAuthorsDetailView = () => {
    const authorName = useSelector((state: IRPStore) => state.article.authorDetail.author.name);
    const description = useSelector((state: IRPStore) => state.article.authorDetail.author.description);
    const locationPathname = useLocation().pathname;
    const authorImageUrl = useSelector((state: IRPStore) => state.article.authorDetail.author.image?.a_img_360x360);

    return (
        <Container>
            <SchemaArticleAuthorDetail name={authorName} description={description} pathname={locationPathname} authorImageUrl={authorImageUrl} />
            <Breadcrumbs css={mb(8)} homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem name="Wiadomości" position="2" url={rpAppLink.article.list()} />
                <BreadcrumbsItem name="Autorzy" position="3" url={rpAppLink.article.author.list()} />
                <BreadcrumbsItem name={authorName} position="4" isLinkingToCurrentLocation />
            </Breadcrumbs>

            <AuthorDescription css={[mb(3), onDesktop(mb(8))]} />
            <AuthorArticlesListing />
        </Container>
    );
};
